import axios from '../helpers/axiosConfig';
import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../helpers/AuthContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import getBaseUrl from '../helpers/utility';

const PersonnelsRetraite = () => {
  const baseUrl = getBaseUrl();

  const navigate = useNavigate();
  const [personnels, setPersonnels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(0);

  /*   const { isAuthenticated } = useContext(AuthContext);

  useEffect(() => {
    if (isAuthenticated.isAuthenticated) {
      navigate('/login');
    }
  }, []); */

  useEffect(() => {
    const token = localStorage.getItem('accessToken');

    const fetchPersonnels = async () => {
      toast.info('Chargement des données ...');
      try {
        const response = await axios.get('/personnel', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await response.data;

        const today = new Date();
        const yearInTwoYears = today.getFullYear() + 2;

        const personnelsRetraite = data.personnels.filter((personnel) => {

          if (personnel.typePers === 'CIVIL') {
            if (personnel.datenaisse) {

              const birthDate = new Date(personnel.datenaisse);

              const retirementAge = personnel.grade.anneeretraite; // 'anneedeservice' stocke l'âge de retraite pour chaque grade
              const retirementYear = birthDate.getFullYear() + retirementAge;

              // Filtrer les personnels dont l'année de retraite est dans les 2 années suivantes
              return retirementYear <= yearInTwoYears && retirementYear >= today.getFullYear();
            }
          }
        });
        // Trier les personnels par année de retraite en ordre croissant
        personnelsRetraite.sort((a, b) => {
          const retirementYearA = new Date(a.datenaisse).getFullYear() + a.grade.anneeretraite;
          const retirementYearB = new Date(b.datenaisse).getFullYear() + b.grade.anneeretraite;

          return retirementYearA - retirementYearB; // Tri par année de retraite en ordre croissant
        });
        setPersonnels(personnelsRetraite);
      } catch (err) {
        toast.error(err);
      }
    };

    fetchPersonnels();
  }, []);

  return (
    <div className="container mt-5 ">
      {personnels.length === 0 ? (
        <p>Chargement des données... </p>
      ) : (
        <>
          <h2>Retraité dans les années suivantes</h2>
          {personnels && (
            <div className="alert alert-danger p-3" style={{ fontFamily: 'impact', fontSize: 40 }}>
              Résultats trouvés : {personnels.length}
            </div>
          )}
          <table className="table table-striped">
            <thead className="table-dark">
              <tr>
                <td>Grade</td>
                <td>Nom et prénoms</td>
                <td>Date de naissance</td>
                <td>Ets. / Sce / Compagnie</td>
                <td>Compagnie</td>
                <td>Photo</td>
                <td>Action</td>
              </tr>
            </thead>
            <tbody>
              {personnels.map((personnel) => (
                <tr key={personnel.id}>
                  <td>{personnel.grade.name}</td>
                  <td>{personnel.nomprenom}</td>
                  <td>{personnel.datenaisse}</td>
                  <td>
                    {personnel.etsouservice && personnel.etsouservice.name}
                    {personnel.compagnie && personnel.compagnie.name}
                  </td>
                  <td>Retraite en {new Date(personnel.datenaisse).getFullYear() + personnel.grade.anneeretraite}</td>
                  <td>
                    <img src={`${baseUrl}/images/personnels/${personnel.filename}`} width="50px" height="50px" alt="" />
                  </td>
                  <td>
                    <i style={{ cursor: 'pointer' }} className="fa fa-eye" onClick={() => navigate(`/personnel/${personnel.id}`)}></i>
                    <i style={{ cursor: 'pointer' }} className="fa fa-edit" onClick={() => navigate(`/personnel/edit/${personnel.id}`)}></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

export default PersonnelsRetraite;
